<template>
  <div>
    <b-modal
        id="create-restaurant"
        hide-header
        hide-footer
        v-model="showModal"
        no-close-on-backdrop
        no-close-on-esc
    >
      <div>
        <b-row>
          <b-col md="12" class="text-center p-2">
            <h3>Modificare utilizator</h3>
          </b-col>
          <b-col md="12">
            <div class="form-group">
              <label>Email (obligatoriu)</label>
              <b-input type="text" v-model="user.email" placeholder="Email"></b-input>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Nume</label>
                  <b-input type="text" v-model="user.last_name" placeholder="Nume (obligatoriu)"></b-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Prenume</label>
                  <b-input type="text" v-model="user.first_name" placeholder="Prenume (obligatoriu)"></b-input>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Adresa</label>
              <b-input type="text" v-model="user.address" placeholder="Strada nr, bloc, ap, etc (obligatoriu)"></b-input>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Oras</label>
                  <b-input type="text" v-model="user.city" placeholder="Oras (obligatoriu)"></b-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Cod Postal</label>
                  <b-input type="text" v-model="user.zip" placeholder="Nu este obligatoriu"></b-input>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Telefon</label>
              <b-input type="text" maxlength="10" v-model="user.phone" placeholder="Telefon (obligatoriu)"></b-input>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Parola</label>
                  <b-input type="text" v-model="user.password" placeholder="Parola (obligatoriu)"></b-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Confirmare Parola</label>
                  <b-input type="text" v-model="user.c_password" placeholder="Confirmare Parola (obligatoriu)"></b-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Status</label>
                  <b-form-select v-model="user.is_active" :options="statuses" size="sm" class="form-control"></b-form-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Tip Utilizator</label>
                  <b-form-select v-model="user.role" :options="roles" size="sm" class="form-control"></b-form-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="user.role === 'city-manager'">
              <label>Procent comision managere oras</label>
              <b-input type="text" v-model="user.city_manager_platform_fee" placeholder="Procent comision"></b-input>
            </div>
            <div class="form-group" v-if="user.role === 'driver'">
              <label>City Manager Owner</label>
              <b-form-select v-model="user.creator_user" :options="cityManagersOptions" size="sm" class="form-control"></b-form-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-button variant="secondary" @click="cancel" style="width: 100%;">Anuleaza</b-button>
          </b-col>
          <b-col md="6">
            <b-button variant="primary" @click="save" style="width: 100%;">Salveaza</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Users from '@/components/adminEndpoints/users'
import { bus } from "../../../main";

export default {
  data() {
    return {
      showModal: false,
      user: {
        email: '',
        password: '',
        c_password: '',
        first_name: '',
        last_name: '',
        role: '',
        address: '',
        zip: '',
        city: '',
        country: '',
        phone: '',
        city_manager_platform_fee: 0,
        is_active: '',
        creator_user: null
      },
      roles: [
        { value: 'administrator', text: 'Administrator' },
        { value: 'city-manager', text: 'City Manager' },
        { value: 'restaurant-manager', text: 'Restaurant Manager' },
        { value: 'customer', text: 'Client' },
        { value: 'driver', text: 'Livrator' }
      ],
      statuses: [
        { value: true, text: 'Activ' },
        { value: false, text: 'Inactiv' },
      ],
      cityManagers: []
    }
  },
  computed: {
    cityManagersOptions() {
      const returnData = []
      this.cityManagers.forEach(user => {
        const tmpObj = {
          value: user.id,
          text: user.email + ' - ' + user.first_name + ' ' + user.last_name
        }
        returnData.push(tmpObj)
      })
      return returnData
    },
  },
  components: {

  },
  methods: {
    cancel() {
      this.showModal = false
      this.user = {
        email: '',
        password: '',
        c_password: '',
        first_name: '',
        last_name: '',
        role: '',
        address: '',
        zip: '',
        city: '',
        country: '',
        phone: '',
        city_manager_platform_fee: 0,
        is_activ: '',
        creator_user: null
      }
    },
    save() {
      Users.update(this.user.id, this.user).then(response => {
        bus.$emit('userUpdated', response.data.data)
        this.cancel()
      })
    },
    getAllCityManagers() {
      const params = {
        page: 1,
        per_page: 100
      }
      const filters = {
        role: 'city-manager'
      }
      Users.getAll(params, filters).then(response => {
        this.cityManagers = response.data.data
      })
    },
  },
  mounted() {
    bus.$on("showAdminUserEditModal", id => {
      Users.get(id).then(response => {
        this.user = response.data.data
        this.showModal = true
      })
    })
    this.getAllCityManagers()
  }
}
</script>
